import { CService } from "./class.base.service";

class FlowService extends CService{
  getStatusWithCount<T = any>(id: string | number, params?: any):Promise<T>{
    return this.api.get<any, T>(`/${this.path}/status-with-count/${id}`,params);
  };
  getStepsByStatus<T = any>(id: string | number, params?: any):Promise<T>{
    return this.api.get<any, T>(`/${this.path}/steps-by-status/${id}`,params);
  };
  //flow/steps-by-status/{status_id}'
}

const flowService = new FlowService("flow");;
export default flowService